import axios from "axios"

export default {
  resetPassword(email, redirectTo) {
    const url = "users/reset-password"

    const data = {
      email,
      redirectTo,
    }

    return axios.post(url, data).then(response => {
      return response.data
    })
  },

  setPassword(password, token) {
    const url = "users/set-password"

    const data = {
      password,
      token,
    }

    return axios.patch(url, data).then(response => {
      return response.data
    })
  },

  getFacebookLoginUrl(appConfig, redirectUrl) {
    const url = "oauth2/social/auth"

    const data = {
      client_id: appConfig.client.id,
      client_secret: appConfig.client.secret,
      network: "facebook",
      redirectUrl,
    }

    return axios.post(url, data).then(response => {
      return response.data
    })
  },

  login(appConfig, credentials) {
    const url = "oauth2/token"

    const data = {
      ...credentials,
      client_id: appConfig.client.id,
      client_secret: appConfig.client.secret,
      grant_type: "password",
      scope: "",
    }

    return axios.post(url, data).then(response => {
      return response.data
    })
  },

  connectWithFacebook(code, redirectUrl) {
    const url = "social/connect/code"

    const data = {
      network: "facebook",
      code,
      redirectUrl,
    }

    return axios.post(url, data).then(response => {
      return response.data
    })
  },

  loginViaFacebookCode(appConfig, code, redirectUrl) {
    const url = "oauth2/social/token"

    const data = {
      client_id: appConfig.client.id,
      client_secret: appConfig.client.secret,
      network: "facebook",
      code,
      redirectUrl,
      registered: true,
    }

    return axios.post(url, data).then(response => {
      return response.data
    })
  },

  registerViaFacebookCode(appConfig, code, redirectUrl) {
    const url = "oauth2/social/token"

    const data = {
      client_id: appConfig.client.id,
      client_secret: appConfig.client.secret,
      network: "facebook",
      code,
      redirectUrl,
      registered: false,
    }

    return axios.post(url, data).then(response => {
      return response.data
    })
  },

  register(appConfig, credentials) {
    const url = "register"

    const data = {
      ...credentials,
      client_id: appConfig.client.id,
      client_secret: appConfig.client.secret,
      appCode: appConfig.app.code,
      verificationUrl: `${window.location.origin}/verify-email?token={token}`,
    }

    return axios.post(url, data).then(response => {
      return response.data
    })
  },

  verifyEmail(token) {
    const url = `verify-email-token/${token}`

    return axios.post(url)
  },

  updateUser(user) {
    const url = `users/${user.id}`
    const data = { ...user }

    return axios.patch(url, data).then(response => {
      return response.data
    })
  },

  changePassword(currentPassword, newPassword) {
    const url = "change-password"
    const data = {
      currentPassword,
      newPassword,
    }

    return axios.patch(url, data).then(response => {
      return response.data
    })
  },
}
